import { Elements } from '@stripe/react-stripe-js';
import type { Stripe, StripeElementsOptions } from '@stripe/stripe-js';

import { useQuery } from '@tanstack/react-query';
import { brokerageFirmControllerGetPaymentMethodSetupSecretQueryOptions } from 'korint-sdk';
import { Spinner } from '../../ui/spinner';
import { CheckoutForm } from './CheckoutForm';
import { Group } from '@folio/components/ui/flex';

export const IntermediaryPaymentMethodSetup = ({
  brokerageFirmId,
  stripePromise,
  confirmSuccess,
}: {
  brokerageFirmId: string;
  stripePromise: Promise<Stripe | null>;
  confirmSuccess: () => Promise<void>;
}) => {
  const { data, status } = useQuery({
    ...brokerageFirmControllerGetPaymentMethodSetupSecretQueryOptions(brokerageFirmId, {}),
    retryDelay: 500,
    retry: failureCount => failureCount <= 10, // Retry up to 10 times
    gcTime: 0, // Never cache the data
  });

  if (status === 'pending') {
    return (
      <Group align="stretch" justify="center" className="py-24">
        <Spinner />
      </Group>
    );
  }

  if (status === 'error') {
    return (
      <Group align="stretch" justify="center" className="py-24">
        Une erreur est survenue. Veuillez réessayer plus tard.
      </Group>
    );
  }

  const options: StripeElementsOptions = {
    clientSecret: data.clientSecret,
    appearance: {
      theme: 'flat',
    },
    locale: 'fr',
  };

  return (
    <Elements stripe={stripePromise} options={options}>
      <CheckoutForm confirmSuccess={confirmSuccess} />
    </Elements>
  );
};
